import styled from 'styled-components/macro';

export const StyledQuestion = styled.p`
  margin-top: 32px;
`;
